import React from "react";
import SVG_CHECK_GREEN from "../../../../../assets/images/vector/components/Paywalls/Customizable/check_green.svg";
import SVG_CROSS_GRAY from "../../../../../assets/images/vector/components/Paywalls/Customizable/cross_gray.svg";
import PropTypes from "prop-types";
import { getTrueClasses } from "../../../../../helpers";

const Mark = ({ customClass, mark }) => {
  const isX = mark === "x";

  return (
    <img
      className={getTrueClasses(customClass, isX && `${customClass}_x`)}
      src={isX ? SVG_CROSS_GRAY : SVG_CHECK_GREEN}
      alt={mark}
    />
  );
};
Mark.propTypes = {
  customClass: PropTypes.string,
  mark: PropTypes.string,
};
export default Mark;
